module.exports = __webpack_public_path__ + "static/media/profilepic.1fce4563.png";